<div>
  <section id="tinyslider" >
    <div class="videohomebg">
      <video style="width: 100%;" autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true">
        <source src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/vidhema-blog.mp4?alt=media&token=1a8ce92a-5a7f-46f5-ae98-0d17b43af753" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="dark"
      style="background:linear-gradient(45deg, #00000052, #000000ba);position: relative;;background-position: center top;width: 100%;">
      <div class="container-fluid clearfix">

        <div class="slider-caption slider-caption-center">

          <h1><strong style="color: #e83d2e;">Stay Ahead:</strong> IT Insights with Vidhema</h1>

          <p>No global movement springs from individuals. It takes an entire team united behind something big. Together,
            we work hard, we laugh a lot, we brainstorm nonstop,and are passionate about the company and our values.</p>

        </div>

      </div>
    </div>


  </section>

  <section class="categories-slider text-center">

    <app-blog-category></app-blog-category>
  </section>


  <section class="search-blog-category text-center">
    <button type="button" class="btn srch_btn" data-bs-toggle="modal" data-bs-target="#exampleModal"
      (click)="showDialog()">
      Search Blogs
    </button>

  </section>
  


  <section class="blog-grid container">
    <div class="blog-list-items row" id="loadmorecontainer">

      <div *ngFor="let blog of filterdata" class="blog-list-item aos-init aos-animate col-md-4" data-item="latest"
        data-aos="fade-up">
        <div id="post-2337" class="blog-list-card">
          <div class="blog-list-card-thumb">
            <a href="{{blog.url}}"><img width="900" height="553" src="{{blog.featured_image}}"
                class="attachment-blog-card size-blog-card wp-post-image" alt="Embrace-IoT-for-Startups"
                decoding="async" loading="lazy"></a>
          </div>
          <div class="blog-list-card-content">
            <span class="blog-meta">{{blog.date | date:'longDate'| titlecase}}</span>
            <h3 class="blog-title"><a href="{{blog?.url}}" title="{{blog.title}}">
                {{blog.title}}</a></h3>
                <p>{{ trimString(blog?.shortDescription,50)}}<a class="readmore" href="{{blog.url}}">Read More</a></p>

          </div>
          
            <img alt="" src="{{blog.authorId.image}}" class="avatar avatar-51 photo" height="51" width="51"
              loading="lazy" decoding="async">
            <div class="blog-list-footer-in">
              <h4>{{blog.authorId.name}}</h4>
              <span>Posts by this author</span>
            </div>

        </div>
      </div>

      
    </div>
  </section>
  <div class="PaginationClass">
    <ul *ngIf="pager.pages && pager.pages.length" class="pagination" :style="ulStyles">
      <li class="page-item first" :class="{'disabled': pager.currentPage === 1}" :style="liStyles">
          <a class="page-link" routerLink="/blog/{{currentCategory}}/1" :style="aStyles"><i class="fa fa-step-backward" aria-hidden="true"></i></a>
      </li>
      <li class="page-item previous" :class="{'disabled': pager.currentPage === 1}" :style="liStyles">
          <a class="page-link" routerLink="/blog/{{currentCategory}}/{{pager.currentPage - 1}}" :style="aStyles"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
      </li>
      <li *ngFor="let page of pager.pages" class="page-item page-number" [ngClass]="{'active': pager.currentPage === page}" :style="liStyles">
          <a class="page-link" routerLink="/blog/{{currentCategory}}/{{page}}" :style="aStyles">{{page}}</a>
      </li>
      <li class="page-item next" *ngIf="hidenext"  :class="{'disabled': pager.currentPage === pager.totalPages}" :style="liStyles">
          <a class="page-link" routerLink="/blog/{{currentCategory}}/{{pager.currentPage + 1}}" :style="aStyles"><i class="fa fa-arrow-right" aria-hidden="true"></i></a>
      </li>
      <li class="page-item last" :class="{'disabled': pager.currentPage === pager.totalPages}" :style="liStyles">
          <a class="page-link" routerLink="/blog/{{currentCategory}}/{{pager.totalPages}}" :style="aStyles"><i class="fa fa-step-forward" aria-hidden="true"></i>
          </a>
      </li>
  </ul>
      </div>


  <section class="blog-grid container latest-blog ">

    <h2>Latest Blogs</h2>

    <div  class="blog-list-items row" id="loadmorecontainer">

      <div *ngFor="let blog of Blogs | slice:0:3; let i = index;" class="blog-list-item aos-init aos-animate col-md-4" data-item="latest" data-aos="fade-up">
        <div  id="post-2337" class="blog-list-card">
          <div class="blog-list-card-thumb">
          <a href="{{blog?.url}}"><img width="900" height="553" src="{{blog?.featured_image}}"
              class="attachment-blog-card size-blog-card wp-post-image" alt="Embrace-IoT-for-Startups"
              decoding="async" loading="lazy"></a>
          </div>
          <div class="blog-list-card-content">
            <span class="blog-meta">{{blog?.date | date:'longDate'| titlecase}}</span>
            <h3 class="blog-title"><a href="{{blog?.url}}"  title="{{blog.title}}">
                {{blog?.title}}</a></h3>
                <!-- <p *ngIf="blog.showdescription">{{ blog?.shortDescription}}
                  <span (click)="blog.showdescription = !blog.showdescription">  Read Less </span>
                </p>
                <p *ngIf="!blog.showdescription">{{ trimString(blog?.shortDescription,50)}}
                  <span  (click)="blog.showdescription = !blog.showdescription"> Read More </span>

                </p> -->
                <!-- <a href="{{blog.url}}"><p>{{ trimString(blog?.shortDescription,50)}}Read More</p></a> -->
                <p>{{ trimString(blog?.shortDescription,50)}}<a class="readmore" href="{{blog.url}}">Read More</a></p>

               
          </div>
        
          <img alt="" src="{{blog?.authorId.image}}" class="avatar avatar-51 photo" height="51" width="51"
            loading="lazy" decoding="async">
          <div class="blog-list-footer-in">
            <h4>{{blog?.authorId.name}}</h4>
            <span>Posts by this author</span>
          </div>
        </div>
      </div>
     
    </div>
  </section>


  <section id="content" class="servesdetails blog">
  
    <app-quoteform></app-quoteform>
  </section>

  <a href="#" id="back-to-top" title="Back to top"><i class="fa fa-arrow-up"></i></a>
</div>